import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Note.module.scss';
import Button from '../../../../Button';
import Loader from '../../../../Loader';
import Trash from '../../../../../assets/svg/Feather/Trash2';
import Pencil from '../../../../../assets/svg/Feather/Pencil';
import { formatDate } from '../../../../../lib/utils';

export default function Note(props) {
  const { isOwner } = props;
  const [contents, setContents] = useState(props.contents);
  const [isEditing, setIsEditing] = useState(false);
  const [isNoteSaveable, setIsNoteSaveable] = useState(true);
  const [title, setTitle] = useState(props.title);

  const editNote = (noteId) => {
    return (e) => {
      setIsEditing(true);
    };
  };

  const cancelEdit = () => {
    setIsEditing(false);
    setIsNoteSaveable(false)
    setContents(props.contents);
    setTitle(props.title);
  };

  const saveEdit = () => {    
    props.onSaveEdit(props.noteId, title, contents);
    setIsEditing(false);
  };

  const handleTitle = (e) => {
    const newTitle = e.target.value
    setTitle(newTitle);
  }

  const handleContents = (e) => {
    const newContents = e.target.value
    setIsNoteSaveable(newContents.trim())
    setContents(newContents);
  }

  return (
    <div className={styles.note}>
      {!isEditing ? (
        <div className={props.isLoading ? styles.loading : ''}>
          <div className={styles.header}>
            <p className={styles.title}>
              <em>{props.title}</em>
            </p>
            <div className={styles.actionSection}>
              {props.isLoading ? (
                <Loader active={true} small />
              ) : (
                <>
                  {isOwner ? (
                    <>
                      <div
                        className={styles.deleteIcon + ' ' + styles.actionIcon}
                        onClick={(e) => {
                          props.onDelete(props.noteId);
                        }}
                      >
                        <Trash width={16} color='#fff' />
                      </div>
                      <div className={styles.editIcon + ' ' + styles.actionIcon} onClick={editNote(props.noteId)}>
                        <Pencil width={16} color='#fff' />
                      </div>

                    </>
                  ) : null}
                </>
              )}
            </div>
          </div>
          <p className={styles.content}>{props.contents}</p>
          <div className={styles.dateLabel}>
            <p>{formatDate(props.updatedAt || props.createdAt)}</p>
          </div>
        </div>
      ) : (
        <div className={styles.editNoteForm}>
          <div className={styles.editInputs}>
            <input
              type='text'
              placeholder='Title'
              value={title}
              maxLength={255}
              onChange={(e) => handleTitle(e)}
            />
            <textarea
              placeholder='Note'
              value={contents}
              onChange={(e) => handleContents(e)}
            />
          </div>
          <div className={styles.buttonsContainer}>
            <Button
              onClick={cancelEdit}
              size={Button.SIZE.small}
              theme={Button.THEME.outlinePrimary}
            >
              Cancel
            </Button>
            <Button 
              disabled={!isNoteSaveable}
              onClick={saveEdit}
              size={Button.SIZE.small}
              theme={Button.THEME.solidPrimary}
            >
              Save Note
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

Note.propTypes = {
  title: PropTypes.string,
  contents: PropTypes.string,
  noteId: PropTypes.string,
  isLoading: PropTypes.bool,
  onDelete: PropTypes.func,
  updatedAt: PropTypes.number,
  createdAt: PropTypes.number,
  onSaveEdit: PropTypes.func,
  isOwner: PropTypes.bool
};
